export { default } from './IconText'
